module.exports = __webpack_public_path__ + "static/img/group_project.3f29788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/group_project.png
// module id = bpTt
// module chunks = 1